<template>
  <div
    v-if="hasValidQRCode"
    class="qrcode-wrapper"
    :class="{
      'fullscreen': isFullScreen,
      [`position-${posicaoEnquete}`]: true
    }"
  >
    <div class="qrcode-container">
      <img
        :src="item.enquete_qr_code.url"
        :alt="qrCodeAltText"
        class="qrcode-image"
        @error="onQRCodeError"
      />
    </div>
    <div class="participe-label">
      <span>Participe!</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTarjaEnqueteFechamentoSportvQRCODE',
  props: {
    item: {
      type: Object,
      default: () => null
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Mono45Headline";
  font-weight: 700;
  src: url("@/assets/fonts/FechamentoSportv/Mono45 Headline Bold.ttf") format("truetype");
}

.qrcode-wrapper {
  --participe-label-background-gradient: linear-gradient(to top, rgb(255, 255, 255), rgb(255, 255, 255));
  --participe-label-text: #373f19;

  position: fixed;
  bottom: 85px;
  left: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  max-width: none;
  margin: 0;
  transition: all 0.3s ease;
  z-index: 100;

  &.fullscreen {
    max-width: 400px;
  }

  &.position-esquerda {
    align-self: flex-start;
  }

  &.position-direita {
    align-self: flex-end;
    left: auto;
    right: 60px;
  }

  &.position-centro {
    align-self: center;
    left: 50%;
    transform: translateX(-50%);
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

.participe-label {
  background: var(--participe-label-background-gradient);
  padding: 8px 30px;
  margin-top: -2px;

  span {
    display: block;
    font-family: 'Mono45Headline', sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: var(--participe-label-text);
    text-align: center;
  }
}
</style>
